import React from 'react';
import pt from 'prop-types';
import styles from './SeniorPastImagesQuickOrder.module.scss';

const TIERS = [
  { count: 2, off: 10 },
  { count: 3, off: 20 },
  { count: 4, off: 30 },
  { count: 5, off: 40, label: '5 or more years' },
];

export default function DiscountPopup({ onClose }) {
  return (
    <div className={styles.popupOverlay} role="dialog" aria-modal="true" aria-labelledby="discount-popup-title">
      <div className={styles.popup}>
        <button
          type="button"
          className={styles.popupClose}
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
        <h2 id="discount-popup-title" className={styles.popupTitle}>Save more on additional pictures!</h2>
        <p className={styles.popupCopy}>
          You can add more pictures to your order and save:
        </p>
        <ul className={styles.popupTiers}>
          {TIERS.map((tier) => (
            <li key={tier.count}>
              <span className={styles.popupTierCount}>{tier.label || `${tier.count} years`}</span>
              <span className={styles.popupTierOff}>{`${tier.off}% off`}</span>
            </li>
          ))}
        </ul>
        <button type="button" className={styles.popupCta} onClick={onClose}>
          Continue Shopping
        </button>
      </div>
    </div>
  );
}

DiscountPopup.propTypes = {
  onClose: pt.func.isRequired,
};
